var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loaded),
      expression: "loaded"
    }],
    staticClass: "order-note bg-white pay-success"
  }, [_c('div', {
    staticClass: "success"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/payicon.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tip"
  }, [_vm._v(_vm._s(_vm.tips))])]), _vm._v(" "), _c('div', {
    staticClass: "explain"
  }, [_vm._v("根据证监会2016年130号令《证券期货投资者适当性管理办法》的要求，在正式开通服务前，还需要您进行以下两项工作，以便我司据此对您进行风险承受能力评估，开展适当性工作。")]), _vm._v(" "), _c('div', {
    staticClass: "row action-row"
  }, [_c('div', {
    staticClass: "ui_cells",
    class: _vm.hightlightRow
  }, [_c('div', {
    staticClass: "ui_cell",
    class: {
      disabled: _vm.has_survey
    },
    on: {
      "click": _vm.toSurvey
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "cell_ft",
    domProps: {
      "textContent": _vm._s(_vm.survey_text)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ui_cell",
    class: {
      disabled: _vm.has_signed
    },
    on: {
      "click": _vm.toSignContract
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "cell_ft",
    domProps: {
      "textContent": _vm._s(_vm.signed_text)
    }
  })])])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "hidden",
    attrs: {
      "id": "jumpFormDiv"
    }
  })])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cell_hd"
  }, [_vm._v("填写"), _c('span', [_vm._v("《投资者风险承受能力问卷》")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cell_hd"
  }, [_vm._v("签订"), _c('span', [_vm._v("《证券投资咨询服务合同》")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wram-tip"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("温馨提示")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n\t\t对您在问卷填写及电子合同签订过程所提供的一切信息，本公司承诺严格按照法律法规要求承担保密义务。未获得法定程序授权前，保证不会将您的隐私信息提供、泄漏给任何第三方，或者将相关信息用于违法、不当用途。\n\t\t")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@13.0.2@vue-loader/lib/template-compiler?{"id":"data-v-ef5b110a","hasScoped":true}!./~/_vue-loader@13.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/customer/OrderPaySuccess.vue
// module id = 257
// module chunks = 0